const prefix = 'hc-radiobutton';

/**
 * Collection of class names inside Checkbox component.
 *
 * These styles basically only mark component in named way in case you want to override styles in parent
 */
export const RadioButtonClassNames = {
  Root: `${prefix}-root`,
  Label: `${prefix}-label`,
  Main: `${prefix}-main`,
  FinishedOverlay: `${prefix}-finished-overlay`,
};

const variablePrefix = `--${prefix}`;

export const RadioButtonVariableNames = {
  InputSize: `${variablePrefix}-input-size`,
  HoverPadding: `${variablePrefix}-hover-padding`,
  InputPadding: `${variablePrefix}-input-padding`,
  TransitionDuration: `${variablePrefix}-transition-duration`,
};
